"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactRouterDom = require("react-router-dom");

var _Form = _interopRequireDefault(require("./Form"));

var PAGING_TAKE = Number(window.env['PAGING_TAKE']);

function Filter() {
  try {
    var handleFormChange = function handleFormChange(_ref) {
      var page = _ref.page,
          take = _ref.take;
      navigate((0, _utils.objectToQuery)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, query), {}, {
        page: page,
        take: take
      })));
    };

    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var meta = (0, _reactRedux.useSelector)(_invoices.selectMeta);
    var values = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('paging-form')) || {};
    var query = (0, _utils.queryToObject)(location['search']);
    var page = values['page'] || 1;
    var take = values['take'] || PAGING_TAKE;
    var totalRow = meta['totalRow'] || 0;
    var takeNumber = typeof take === 'number' ? take : PAGING_TAKE;
    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      formState: {
        page: typeof page === 'number' ? page : 1,
        take: takeNumber,
        pages: totalRow && Math.ceil(totalRow / takeNumber),
        totalRow: totalRow
      },
      initialValues: {
        page: typeof query['page'] === 'number' ? query['page'] : 1,
        take: typeof query['take'] === 'number' ? query['take'] : PAGING_TAKE,
        totalRow: totalRow
      },
      onSubmit: function onSubmit(data) {
        return handleFormChange(data);
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Filter;
exports["default"] = _default;